import React from "react";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import moment from "moment";
import { TwoLine, TypeBadge, StageBadge, SlaFlag } from "../components/Badges";
import { isBreach } from "../config/sla";

const relativeTime = function (value) {
  if (!value) return "—";
  const m = moment(value);
  return m.isValid() ? m.fromNow() : "—";
};

/*
One case. The whole row is the click target (as designed), so it also has to be
reachable and activatable from the keyboard.
*/
const CaseRow = function (props) {
  const { row, onOpen } = props;

  const open = function () {
    onOpen(row);
  };

  return (
    <TableRow
      hover
      className={"tn-row" + (isBreach(row.sla_status) ? " tn-row-breach" : "")}
      onClick={open}
      role="button"
      tabIndex={0}
      onKeyDown={function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          open();
        }
      }}
    >
      <TableCell className="tn-cell tn-mono tn-cell-ref">
        {row.ticket_number || "—"}
      </TableCell>
      <TableCell className="tn-cell">
        <TwoLine top={row.owner_name} bottom={row.customer_location} />
      </TableCell>
      <TableCell className="tn-cell">
        <TwoLine top={row.device_name} bottom={row.sku} mono />
      </TableCell>
      <TableCell className="tn-cell">{row.retailer || "—"}</TableCell>
      <TableCell className="tn-cell">
        <TypeBadge value={row.type_label} />
      </TableCell>
      <TableCell className="tn-cell">
        <StageBadge value={row.stage} />
      </TableCell>
      <TableCell className="tn-cell">
        <SlaFlag value={row.sla_status} />
      </TableCell>
      <TableCell className="tn-cell tn-cell-muted">
        {relativeTime(row.last_activity_date)}
      </TableCell>
    </TableRow>
  );
};

export default CaseRow;
